import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import adoridabuilding from '../../../../../Assets/adore-imgs/shop.webp'
const ShaeduleAnAppointment = () => {
  const history = useHistory();
  return (
    <section className="custom-design">
      <Container fluid className="showcase-container">
        <Row className="align-items-center">
          <Col md={7} xs={12} className="text-center">
            <Image src={adoridabuilding} alt="adoridabuilding" className="img-fluid" />
          </Col>
          <Col md={5} xs={12}>
            <Heading className="text-md-left">
              <h2 className="text-uppercase">Schedule an Appointment</h2>
              <p>
                Although we ship our jewelry worldwide, we always enjoy meeting our customers in person.
              </p>
              <br></br>
              <p>Call us at  +1 (972)-781-1300 or make an appointment online or to schedule a personalized visit with a jewelry specialist.</p>
              <div className="text-lg-left mt-4">
                <button className="button_black_border"
                  onClick={() => {
                    window.open("https://bookings.cloud.microsoft/book/AdoreBijouxJewelers@NETORG3893906.onmicrosoft.com/?ismsaljsauthenabled", "_blank");
                  }}
                >
                  Schedule an Appointment
                </button>
              </div>
            </Heading>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ShaeduleAnAppointment;
